module.exports = __webpack_public_path__ + "img/img52.20ee98e3.png";